/**
 * interaction/facades/batch.facade.js
 *
 * Sole business entry point for the batch analysis domain.
 * Bridges presentation → transport.
 *
 * Rules: R4 (no DOM / state.js reads), R5 (single domain per PR).
 *
 * Methods:
 *   createBatch(body)               → create batch analysis job
 *   getBatchJob(jobId, options)     → get job status
 *   checkSif()                      → check SIF module readiness/login state
 *   startSifLoginSession(body)      → open SIF login QR session
 *   refreshSifLoginSession(body)    → refresh SIF login QR session
 *   getBatchJobs()                  → list user's jobs
 *   getBatchJobKeywords(jobId)      → get keyword library
 *   previewBatchKeywordStrategy(jobId, body) → rebuild current Step02 strategy
 *   getAsinSnapshotJob(jobId)       → get ASIN snapshot job
 */

export function createBatchFacade(deps) {
  const getDeps = () => deps;

  async function facadeCreateBatch(body) {
    return getDeps().createBatch(body);
  }

  async function facadeGetBatchJob(jobId, options = {}) {
    if (!jobId) throw new Error('getBatchJob() requires a jobId');
    return getDeps().getBatchJob(jobId, options);
  }

  async function facadeGetBatchJobs() {
    return getDeps().getBatchJobs();
  }

  async function facadeCheckSif() {
    return getDeps().checkSif();
  }

  async function facadeStartSifLoginSession(body = {}) {
    return getDeps().startSifLoginSession(body);
  }

  async function facadeRefreshSifLoginSession(body = {}) {
    return getDeps().refreshSifLoginSession(body);
  }

  async function facadeGetBatchJobKeywords(jobId) {
    if (!jobId) throw new Error('getBatchJobKeywords() requires a jobId');
    return getDeps().getBatchJobKeywords(jobId);
  }

  async function facadePreviewBatchKeywordStrategy(jobId, body = {}) {
    if (!jobId) throw new Error('previewBatchKeywordStrategy() requires a jobId');
    return getDeps().previewBatchKeywordStrategy(jobId, body);
  }


  async function facadeGetAsinSnapshotJob(jobId) {
    if (!jobId) throw new Error('getAsinSnapshotJob() requires a jobId');
    return getDeps().getAsinSnapshotJob(jobId);
  }

  return {
    createBatch: facadeCreateBatch,
    getBatchJob: facadeGetBatchJob,
    checkSif: facadeCheckSif,
    startSifLoginSession: facadeStartSifLoginSession,
    refreshSifLoginSession: facadeRefreshSifLoginSession,
    getBatchJobs: facadeGetBatchJobs,
    getBatchJobKeywords: facadeGetBatchJobKeywords,
    previewBatchKeywordStrategy: facadePreviewBatchKeywordStrategy,
    getAsinSnapshotJob: facadeGetAsinSnapshotJob,
  };
}
